import { AxiosError } from 'axios';
import { formatDate, DateFormat, parseDate } from './dateFormatter';
import { ApiErrorResponse } from '../types/ApiErrorResponse';
import { Product } from '../constants/AppConstants';

export const supportedLanguage = ['en', 'id'];

// eslint-disable-next-line arrow-body-style
export const getErrorMsg = (responseData: ApiErrorResponse, err: AxiosError) => {
  return (responseData?.errors?.[0]?.message
    || responseData?.error
    || err.response?.statusText
    || err.message
  );
};

export const downloadBase64ContentAsPdf = (bodyBase64: string, fileName: string, contentType = 'application/pdf', sliceSize = 512) => {
  const byteCharacters = atob(bodyBase64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  const fileURL = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = fileURL;
  link.download = fileName;
  link.click();
};

export const getContractPdfFilename = (loanId: string, timeStamp: string) => {
  const productId = getCurrentProductId();
  return `${productId || ''}LoanContract_${timeStamp ? formatDate(parseDate(timeStamp), DateFormat.DDMMYYYY) : formatDate(new Date(), DateFormat.DDMMYYYY)}_${loanId}.pdf`;
};

export const getCurrentProductId = (): Product | undefined => {
  const path = window.location.pathname;
  const currentProductId = path.split('/')[1];
  let selectedProduct: Product | undefined;

  Object.keys(Product).forEach((productKey) => {
    const product = Product[productKey as keyof typeof Product];
    if (product.toUpperCase() === currentProductId.toUpperCase()) {
      selectedProduct = product;
    }
  });

  return selectedProduct;
};

export const QrsToObj = (str: string) => {
  const search = str.substring(1);
  // eslint-disable-next-line  @typescript-eslint/no-unsafe-return
  return search
    ? JSON.parse(`{"${search.replace(/&/g, '","').replace(/=/g, '":"')}"}`, (
      key: string,
      value: string,
    ) => (key === '' ? value : decodeURIComponent(value)))
    : {};
};

export const separateFourDigitNumber = (numText: string) => {
  const checkNum = numText?.match(/.{1,4}/g) || [''];
  const results = checkNum.join(' - ');
  return results;
};

export const getInvoicePdfFilename = (loanId: string, timeStamp?: string): string => {
  const productId = getCurrentProductId();
  return `${productId || ''}Invoice_${timeStamp ? formatDate(parseDate(timeStamp), DateFormat.DDMMYYYY) : formatDate(new Date(), DateFormat.DDMMYYYY)}_${loanId}.pdf`;
};

export const getShorterLoanId = (loanId: string) => loanId.substring(loanId.length - 4);

export const getKeyByValue = (
  object: any,
  value: any,
// eslint-disable-next-line max-len
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
) => Object.keys(object).filter((key) => object[key] === value);
